import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './LoginPage.module.css';
import logo from '../assets/logo.png';

export default function LoginPage() {
  const { login }    = useAuth();
  const navigate     = useNavigate();
  const [form, setForm]     = useState({ email: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      {/* Panel izquierdo decorativo — solo escritorio */}
      <div className={styles.panel}>
        <div className={styles.panelContent}>
          <img src={logo} alt="EduPortal" className={styles.logoMark} />
          <h2 className={styles.panelTitle}>EduPortal</h2>
          <p className={styles.panelSub}>Plataforma académica universitaria</p>
          <div className={styles.deco} />
        </div>
      </div>

      {/* Formulario */}
      <div className={styles.formSide}>
        <div className={styles.formBox}>
          {/* Logo compacto para móvil */}
          <div className={styles.mobileHeader}>
            <img src={logo} alt="EduPortal" className={styles.mobileLogo} />
            <div>
              <p className={styles.mobileTitle}>EduPortal</p>
              <p className={styles.mobileSub}>Plataforma académica universitaria</p>
            </div>
          </div>

          <h1 className={styles.heading}>Bienvenido</h1>
          <p className={styles.sub}>Accede con tu cuenta institucional</p>

          <form onSubmit={submit} className={styles.form}>
            <label className={styles.label}>
              Correo electrónico
              <input
                className={styles.input}
                type="email" name="email"
                value={form.email} onChange={handle}
                placeholder="usuario@ual.es"
                autoComplete="email"
                required
              />
            </label>
            <label className={styles.label}>
              Contraseña
              <input
                className={styles.input}
                type="password" name="password"
                value={form.password} onChange={handle}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
            </label>
            {error && <p className={styles.error}>{error}</p>}
            <button className={styles.btn} type="submit" disabled={loading}>
              {loading ? 'Entrando...' : 'Iniciar sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
